import type { Filter_FacetsFragment } from '@generated/graphql'

export const jewelryFacetsFilteredFormatted = (
  filteredFacets?: Filter_FacetsFragment[]
) => {
  const excludedFacets = ['brand']

  return (
    filteredFacets?.filter(
      (item) =>
        ((item?.__typename === 'StoreFacetBoolean' &&
          item?.values?.length > 1) ||
          item?.key === 'price') &&
        !excludedFacets.includes(item?.key)
    ) ?? []
  )
}
